import { http } from "@/shared/lib/api/http"
import type { BranchFinanceBoardOverview } from "@ibada/shared-types/overview"

/** ADR-0003 success envelope. */
type Envelope<T> = { data?: T | null }

export type BranchBoardQuery = {
  workspaceId: string
  branchId: string
  dateFrom: string
  dateTo: string
}

/** `GET /finance/overview/branch`: the branch board's own figures. Disclosure is decided server-side. */
export async function fetchBranchBoard(query: BranchBoardQuery): Promise<BranchFinanceBoardOverview> {
  const response = await http.get<Envelope<BranchFinanceBoardOverview>>("/finance/overview/branch", { params: query })
  const data = response.data?.data
  if (!data) throw new Error("Branch finance board: empty response")
  return data
}
